import type { ReactNode } from 'react'

import { ChatItemRenderer } from './chat-item-renderer.atom'
import type { ChatItem } from './chat-message.interface'
import type { ChatVirtuosoRenderItemConfig } from './chat-virtuoso-wrapper.atom'

interface ChatVirtualListItemProps extends ChatVirtuosoRenderItemConfig {
  item: ChatItem
}

const ITEM_STYLE = {
  contain: 'layout style paint' as const,
  contentVisibility: 'auto' as const,
  containIntrinsicSize: '0 100px',
}

export const ChatVirtualListItem: React.FC<ChatVirtualListItemProps> = (props): ReactNode => (
  <div className="chat-item mx-auto w-full max-w-3xl px-4" style={ITEM_STYLE}>
    <ChatItemRenderer {...props} />
  </div>
)
